<template>
	<div>
		<b-overlay
			:show="LoaderStatus"
			:opacity="overlayOpacity"
			rounded="sm"
			style="height: 90%"
		>
			<div
				:class="
					viewQuestionBank ? 'view-sel-ques-container' : 'sel-ques-container'
				"
			>
				<!-- <div
        style="
          position: fixed;
          top: 20px;
          z-index: 1;
          backdrop-filter: blur(2px);
        "
        v-if="LoaderStatus"
      >
        <Spinner />
      </div> -->
				<div style="height: 80%">
					<div class="d-flex align-items-center">
						<div
							v-if="viewQuestionBank"
							class="minimize-right mt-2 ml-n3 pointer"
							@click="$emit('changeViewDataBank')"
						>
							<img
								src="../../assets/icons/Qpbuilder/minimizeright.svg"
								alt=""
							/>
						</div>
						<div v-if="viewQuestionBank" class="sec-qb-text-view ml-3 mt-1">
							Select Questions from Question Bank
						</div>
					</div>
					<div
						class="d-flex align-items-center pl-3 pr-3 pt-3 pb-0 justify-content-between"
					>
						<div
							v-if="!viewQuestionBank"
							class="minimize-right ml-n4 pointer"
							@click="$emit('changeViewQuestionBank')"
						>
							<img src="../../assets/icons/Qpbuilder/minimizeleft.svg" alt="" />
						</div>

						<div class="sec-qb-text" v-if="!viewQuestionBank">
							Question Bank
						</div>

						<div class="ml-3 relativeclass search-width">
							<img
								style="position: absolute; top: 13px; left: 5px"
								src="../../assets/searchicon.svg"
								alt=""
							/>
							<b-form-input
								placeholder="Search Question"
								v-model="searchname"
								@update="searchnameupdate(), searchpagination()"
								class="search-ques"
								debounce="500"
							></b-form-input>
							<div class="searchicon">
								<img
									v-if="searchname.length != 0"
									src="../../assets/icons/Qpbuilder/cross.svg"
									alt=""
									@click="clearSearch"
									class="pointer"
								/>
							</div>
						</div>
						<div class="d-flex align-items-center">
							<div class="ml-3 relativeclass">
								<img
									v-b-popover.hover.top="'Sort'"
									src="../../assets/sorticon.svg"
									alt=""
									class="pointer"
									@click="
										(showsortcard = !showsortcard), (showfiltercard = false)
									"
									v-closable="{
										exclude: ['sortcard'],
										handler: 'hideSortFunction',
									}"
								/>

								<div v-if="showsortcard" ref="sortcard">
									<div class="databank-sortcard d-flex align-items-center p-1">
										<div
											@click="showsortcard = !showsortcard"
											class="xMarkCancel pointer"
										>
											<img src="../../assets/xmark.svg" alt="" />
										</div>
										<b-form-group class="sec-mcq-datacard jdtyperadio pt-2">
											<b-form-radio-group
												class="sort-radio-color pointer jdtyperadio"
												size="sm"
												v-model="sortoptions_selected"
												:options="sortoptions"
												@change="saveDatabankSort(), (showsortcard = false)"
												text-field="text"
												value-field="value"
											>
											</b-form-radio-group>
										</b-form-group>
									</div>
								</div>
							</div>
							<div
								class="sort-applied mb-3"
								v-if="sortoptions_selected != ''"
							></div>

							<div class="ml-3 position-relative" ref="filtershowicon">
								<img
									src="../../assets/filtericon.svg"
									v-b-popover.hover.top="'Filter'"
									alt=""
									class="pointer"
									@click="filterFunction"
									v-closable="{
										exclude: ['filtercard'],
										handler: 'hideFilterFunction',
									}"
								/>

								<div v-if="showfiltercard" ref="filtercard">
									<div
										class="d-flex align-items-center relativeclass"
										:class="
											viewQuestionBank
												? 'view-databank-filtercard'
												: 'databank-filtercard'
										"
									>
										<div class="w-100">
											<div class="qb-fm-heading mb-2">
												<div
													@click="showfiltercard = false"
													class="xMarkCancel pointer"
												>
													<img src="../../assets/xmark.svg" alt="" />
												</div>
												Filter By
											</div>
											<b-row v-if="!selectedSection.communicationSection">
												<b-col>
													<div class="topDiv mt-3">
														<label class="fieldsetStyle sharelabel"
															>Question Type</label
														>
														<div
															ref="chooseType"
															class="qb-dropdown-diffy d-flex justify-content-between pointer"
															@click="
																(dbfilterdrop = !dbfilterdrop),
																	(showdiffoptions = false),
																	(questionTagOpen = false)
															"
														>
															<span v-if="filter.questionType.length == 0"
																>Choose options</span
															>
															<span v-else
																><span
																	v-for="(i, index) in filter.questionType"
																	:key="index + 'qt'"
																>
																	<span v-if="i == 'MCQU'">MCQ</span>
																	<span v-if="i == 'MAFO'">MTF</span>
																	<span v-if="i == 'LONG'">DESC</span>
																	<span
																		v-if="
																			index != filter.questionType.length - 1
																		"
																		>,
																	</span>
																</span></span
															>
															<span>
																<img
																	v-if="!dbfilterdrop"
																	src="../../assets/assess-main-downArrow.svg"
																	alt=""
																/>
																<img
																	v-else
																	src="../../assets/assess-main-upArrow.svg"
																	alt=""
																/>
															</span>
														</div>
														<div
															v-closable="{
																exclude: ['dbfilterdrop1', 'chooseType'],
																handler: 'hideFilterquestiontype',
															}"
															v-if="dbfilterdrop"
															ref="dbfilterdrop1"
															class="qb-dropdown-option-add d-flex secdropdowncolor"
														>
															<b-form-group class="qb-dd-group">
																<b-form-checkbox
																	class="qb-dropdown-option-sing pointer text-align-center"
																	v-for="(option,
																	index) in filter_questiontype_options"
																	:key="index + 'qtp'"
																	:value="option.value"
																	value-field="value"
																	text-field="text"
																	name="radio-btn-stacked"
																	v-model="filter.questionType"
																	stacked
																>
																	{{ option.text }}
																</b-form-checkbox>
															</b-form-group>
														</div>
													</div>
												</b-col>
											</b-row>

											<b-row>
												<b-col
													cols="4"
													v-if="!selectedSection.communicationSection"
												>
													<div class="topDiv mt-3">
														<label class="fieldsetStyle">Marks &nbsp;</label>
														<b-form-input
															class=""
															id="input-1"
															v-model="filter.marks"
															type="number"
															@keypress="avoidNegativeAndOutOfRange"
															min="0"
															max="99"
														></b-form-input>
													</div>
												</b-col>
												<b-col
													:cols="
														!selectedSection.communicationSection ? '8' : '12'
													"
												>
													<div
														class="topDiv mt-3 align-items-center justify-cotent-center addtype-sections"
													>
														<label class="fieldsetStyle"
															>Difficulty Level &nbsp;</label
														>
														<div class="relativeclass">
															<div
																class="filterselect pointer"
																@click="
																	(showdiffoptions = !showdiffoptions),
																		((dbfilterdrop = false),
																		(questionTagOpen = false))
																"
																ref="filterdiffoptions2"
															>
																<b-form-input
																	:placeholder="
																		`${filter.difficulty.length ||
																			'Select'} options selected`
																	"
																	class="filterinputField pointer"
																	readonly
																>
																</b-form-input>

																<div class="diff-downarrow">
																	<img
																		v-if="!showdiffoptions"
																		src="../../assets/assess-main-downArrow.svg"
																		alt=""
																		class="mr-2 mt-2"
																	/>
																	<img
																		v-else
																		class="mr-2 mt-2"
																		src="../../assets/assess-main-upArrow.svg"
																		alt=""
																	/>
																</div>
															</div>
															<div
																v-if="showdiffoptions"
																class="filter-diff-dropdown d-flex"
																ref="filterdiffoptions"
																v-closable="{
																	exclude: [
																		'filterdiffoptions',
																		'filterdiffoptions2',
																	],
																	handler: 'hidediffoptions',
																}"
															>
																<b-form-group class="sec-mcq-datacard">
																	<b-form-checkbox-group
																		class="text-align-center p-2"
																		id="btn-radios-3"
																		:options="diffoptions"
																		value-field="value"
																		text-field="text"
																		name="radio-btn-stacked"
																		v-model="filter.difficulty"
																		stacked
																	></b-form-checkbox-group>
																</b-form-group>
															</div>
														</div>
													</div>
												</b-col>
											</b-row>
											<b-row class="mt-3">
												<b-col>
													<div ref="filterQuestionTag">
														<label
															class="fieldsetStyle"
															style="position: absolute; left: 1.3vw"
															>Question Tags</label
														>
														<div
															class="qb-dropdown-diffy d-flex justify-content-between pointer"
															@click="
																(questionTagOpen = !questionTagOpen),
																	(dbfilterdrop = false),
																	(showdiffoptions = false)
															"
															v-closable="{
																exclude: ['recdropdown', 'filterQuestionTag'],
																handler: 'hidequestagopen',
															}"
														>
															<span
																class="cj-noofrecoption"
																v-if="filter.questionTags.length == 1"
															>
																{{ filter.questionTags.length }}
																question tag selected
															</span>
															<span
																class="cj-noofrecoption"
																v-else-if="filter.questionTags.length != 0"
															>
																{{ filter.questionTags.length }}
																question tags selected
															</span>
															<span class="cj-noofrecoption" v-else>
																Select Tag(s)..</span
															>
															<span>
																<img
																	v-if="!questionTagOpen"
																	src="../../assets/assess-main-downArrow.svg"
																	alt=""
																	class="mr-1"
																/>
																<img
																	v-else
																	class="mr-1"
																	src="../../assets/assess-main-upArrow.svg"
																	alt=""
																/>
															</span>
														</div>
													</div>
													<div
														v-if="questionTagOpen"
														class="qb-dropdown-option-add"
														style="width: 91%"
														ref="recdropdown"
													>
														<div class="relativeclass">
															<b-form-input
																class="db-inputField"
																type="search"
																placeholder="Search.."
																v-model="searchquestiontag"
															>
															</b-form-input>
															<div class="db-searchicon">
																<img src="../../assets/searchicon.svg" alt="" />
															</div>
															<b-form-group class="rec-dd-group">
																<b-form-checkbox
																	class="qb-dropdown-option-sing pointer m-1"
																	size="sm"
																	v-for="(option,
																	index) in filterallQuestionTags"
																	:key="index"
																	:value="option"
																	v-model.trim="filter.questionTags"
																	name="flavour-4a"
																>
																	{{ option }}
																</b-form-checkbox>
															</b-form-group>

															<div
																v-if="filterallQuestionTags.length == 0"
																class="text-center"
															>
																<span class="filter-search-notfound"
																	>No matching results for
																	<span class="filter-search-text text-break">
																		"{{ searchquestiontag }}"
																	</span>
																	.</span
																>
															</div>
														</div>
													</div>
												</b-col>
											</b-row>
											<b-row class="mt-3">
												<b-col>
													<div>
														<label class="fieldsetStyle">Media Type</label>
													</div>

													<div class="d-flex justify-content-between p-2">
														<b-form-checkbox-group
															size="sm"
															v-model="selected"
															:options="mediatypeOptions"
														></b-form-checkbox-group>
													</div>
												</b-col>
											</b-row>

											<div
												class="d-flex align-items-center justify-content-between mt-4"
											>
												<div
													class="clearfilter pointer mt-3"
													:class="
														clearFilterclass
															? filtercount == 0
																? 'disabled-text'
																: 'pointer'
															: 'pointer'
													"
													@click="
														clearFilterclass
															? filtercount == 0
																? clearfilterbox()
																: clearfilter()
															: filtercount == 0
															? clearfilterbox()
															: clearfilter()
													"
												>
													Clear Filter
												</div>
												<div>
													<b-button
														class="addbtn"
														:disabled="clearFilterclass"
														@click="applyfilter(), (showfiltercard = false)"
													>
														Apply
													</b-button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="filter-count mb-3 mr-2" v-if="filtercount != 0">
								{{ filtercount }}
							</div>

							<div class="ml-3">
								<b-button
									v-show="roles.includes(role)"
									variant=""
									:disabled="selectedQuestions.length == 0 || isLocked"
									@click="
										selectedQuestions.length == 0 ? '' : moveAllQuestions()
									"
									:class="
										selectedQuestions.length == 0
											? 'disabledbtn pl-2 pr-2'
											: 'addbtn pl-2 pr-2'
									"
									>Add to Section
								</b-button>
							</div>
						</div>
					</div>

					<div class="pl-2 pb-2 pr-2 pt-0 h-100">
						<template
							v-if="questionBankData.length === 0 && LoaderStatus == false"
						>
							<div
								v-if="searchname == '' && questionBankData.length === 0"
								class="d-flex flex-column align-items-center justify-content-center h-100"
							>
								<div>
									<img src="../../assets/searchnotfound.svg" alt="" />
								</div>
								<div>
									<span class="searchnotfound">No questions available.</span>
								</div>
							</div>
							<div
								v-if="searchname != '' && searchname != 'Loader'"
								class="d-flex flex-column align-items-center justify-content-center h-100"
							>
								<div>
									<img src="../../assets/searchnotfound.svg" alt="" />
								</div>
								<div class="text-center">
									<span class="searchnotfound"
										>No matching results for
										<span class="searchtext text-break">
											"{{ searchname }}"
										</span>
										.</span
									>
								</div>
							</div>
						</template>
						<template v-if="questionBankData.length > 0">
							<div
								class="d-flex justify-content-between pt-1 mt-1"
								v-if="roles.includes(role)"
							>
								<div
									class="d-flex align-items-center p-1 mcq-custom-zindex pl-3"
								>
									<b-form-checkbox
										:disabled="isLocked"
										class="sec-checboxtext"
										name="mcqmtfcheck"
										v-model="selectall"
										@change="selectAll()"
									/>
									<label class="selectall pt-3"> Select All Questions</label>
								</div>
								<label class="selectall pt-3">
									Total Selected Questions:
									{{ this.selectedQuestions.length }}</label
								>
							</div>
							<div class="view-over-page" id="viewqpques">
								<div
									v-for="(ques, index) in questionBankData"
									:key="ques.questionKey"
									:id="ques.questionKey"
								>
									<div
										class="p-3"
										:class="
											selectedQuestions.includes(ques.questionKey)
												? 'selquessubcontainer'
												: viewQuestionBank
												? 'dbquesfullcards'
												: 'dbquescards'
										"
									>
										<div
											class="d-flex align-items-center justify-content-between"
											style="height: 60px"
										>
											<div class="d-flex align-items-center">
												<div
													class="mcq-custom-zindex"
													v-if="roles.includes(role)"
												>
													<b-form-checkbox
														class="sec-checboxtext"
														name="mcqmtfcheck"
														:value="ques.questionKey"
														v-model="selectedQuestions"
														@change="deselect()"
														:disabled="isLocked"
													>
													</b-form-checkbox>
												</div>

												<div
													class="db-mcqtophead ml-2"
													v-if="
														ques['questionKey'].slice(0, 4) == 'MCQU' ||
															ques['questionKey'].slice(0, 4) == 'MAFO' ||
															ques['questionKey'].slice(0, 4) == 'LONG'
													"
												>
													<template
														v-if="ques['questionKey'].slice(0, 4) == 'MCQU'"
													>
														MCQ
													</template>
													<template
														v-if="ques['questionKey'].slice(0, 4) == 'MAFO'"
													>
														MTF
													</template>
													<template
														v-if="ques['questionKey'].slice(0, 4) == 'LONG'"
													>
														DESC
													</template>
												</div>
												<div class="db-mcqtophead ml-3">
													Difficulty Level - {{ ques.difficultyLevel }}
												</div>
												<div class="db-mcqtophead ml-3">
													{{ ques.marks }} Marks
												</div>
											</div>

											<b-button
												:disabled="isLocked"
												class="addbtn mr-n2"
												v-show="
													selectedQuestions.length == 0 && roles.includes(role)
												"
												@click="
													addQuestionFromDB(
														ques,
														ques['questionKey'].slice(0, 4)
													)
												"
												>Add Question</b-button
											>
										</div>

										<div class="db-ques-style">
											<div class="my-3" v-if="ques.questionMedia != null">
												<div v-if="isImage(ques.questionMediaType)">
													<img
														class="qb-image-preview"
														:src="ques.questionMedia"
														alt=""
													/>
												</div>
												<div v-if="isAudio(ques.questionMediaType)">
													<Media
														:kind="'audio'"
														:isMuted="false"
														:src="ques.questionMedia"
														:autoplay="false"
														:controls="true"
														:loop="true"
														width="70%"
														class="qb-audio-preview"
													></Media>
												</div>
												<div v-if="isVideo(ques.questionMediaType)">
													<Media
														:kind="'video'"
														:isMuted="false"
														:src="ques.questionMedia"
														:autoplay="false"
														:controls="true"
														:loop="true"
														width="70%"
														height="30%"
														class="qb-vedio-preview"
													></Media>
												</div>
											</div>
											<div class="d-flex">
												<div>Q{{ pageStart + index }}.</div>
												<div
													class="ml-1 db-ques-index"
													v-html-safe="ques.question"
												></div>
											</div>
											<template
												v-if="ques['questionKey'].slice(0, 4) == 'MCQU'"
											>
												<div
													class="ml-5 mt-2  mcq-custom-zindex"
													:class="{
														dbmradios: ques.noOfCorrectOptionsAllowed <= 1,
													}"
												>
													<b-row v-if="ques.noOfCorrectOptionsAllowed > 1">
														<b-col
															v-for="(i, index1) in ques.options"
															:key="index1"
															cols="6"
															class="mcq-checkbox"
															:class="{
																'mt-3': index1 > 1,
															}"
														>
															<b-form-checkbox
																class=""
																disabled
																v-model="i.check"
																><span v-if="i.value"> {{ i.value }}</span>
																<span v-if="i.media">
																	<span class="uploaded-option-imagecard">
																		<img
																			:src="i.media"
																			alt=""
																			class="w-100 h-100 overflow-hidden"
																			style="border-radius: 4px;"
																		/>
																	</span>
																</span>
															</b-form-checkbox>
															<!-- give filter "topicNameFilter" -->
														</b-col>
													</b-row>
													<b-form-radio-group
														v-else
														id="radio-group-2"
														name="radio-sub-component"
													>
														<b-row>
															<b-col
																v-for="(i, index1) in ques.options"
																:key="index1"
																cols="6"
																class="sec-questions-radios"
																:class="
																	i.check == true
																		? 'sec-ques-green'
																		: 'sec-questions-radios'
																"
															>
																<b-form-radio disabled value="first"
																	><span v-if="i.value"> {{ i.value }}</span>
																	<span v-if="i.media">
																		<span class="uploaded-option-imagecard">
																			<img
																				:src="i.media"
																				alt=""
																				class="w-100 h-100 overflow-hidden"
																				style="border-radius: 4px;"
																			/>
																		</span>
																	</span>
																</b-form-radio>
																<!-- give filter "topicNameFilter" -->
															</b-col>
														</b-row>
													</b-form-radio-group>
												</div>
											</template>
											<template
												v-if="ques['questionKey'].slice(0, 4) == 'MAFO'"
											>
												<div
													class="mofo-answrdiv d-flex justify-content-between"
													v-for="(i, index2) in ques.answerKey"
													:key="index2"
												>
													<div
														class="mafo-option-text d-flex pl-2 align-items-center"
													>
														{{ i.sideA }}
													</div>
													<div
														class="mafo-option-text ml-4 d-flex align-items-center"
													>
														<div
															class="d-flex align-items-center disablesixdots"
														>
															<img
																src="../../assets/disablesixdots.svg"
																alt=""
															/>
														</div>
														<div class="ml-2 d-flex align-items-center">
															{{ i.sideB }}
														</div>
													</div>
												</div>
											</template>
											<template
												v-if="ques['questionKey'].slice(0, 4) == 'LONG'"
											>
												<div v-html-safe="ques.correctAnswer"></div>
											</template>
										</div>
									</div>
									<hr />
								</div>
								<div
									class="text-center"
									v-if="
										!viewQuestionBank && total > 50 && LoaderStatus == false
									"
								>
									<b-button
										class="addbtn"
										@click="
											$emit('changeViewQuestionBank'),
												(currentPage = 2),
												getQuestionBankData(),
												(addMulti = true)
										"
										>Show More Questions</b-button
									>
								</div>
							</div>
						</template>
					</div>
				</div>
				<template v-if="questionBankData.length != 0">
					<div
						v-if="viewQuestionBank"
						class="qbpaginaTion d-flex justify-content-between align-items-center page-alignment p-1"
					>
						<div class="d-flex">
							<span class="qb-gotopage-text p-1">Go to page</span>
							<b-form-input
								type="text"
								class="qb-pagination-num mr-1"
								v-model.trim="goToPage"
								@keyup.enter="
									goToPage === null || goToPage == '' || iscontainsNumber
										? ''
										: goToPageNo(goToPage)
								"
							></b-form-input>
							<b-button
								:disabled="
									goToPage === null || goToPage == '' || iscontainsNumber
								"
								class="qb-pagination-addbtn"
								@click="goToPageNo(goToPage)"
							>
								<span
									><img src="../../assets/whiterightarrow.svg" alt=""
								/></span>
							</b-button>
						</div>

						<div class="pagination">
							<b-pagination
								v-model.number="currentPage"
								:total-rows="total"
								:per-page="question_count"
								@input="goToPageNum()"
								align="center"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>
								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>
						<div class="qb-gotopage-text mr-2">
							Results : <span v-if="pageStart > total">0</span
							><span v-else>{{ pageStart }}</span> - {{ pageEnd }}

							<span class="pl-1"></span> of <span class="pr-1"></span
							>{{ total }}
						</div>
					</div>
				</template>
			</div>
		</b-overlay>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
import {
	getDataBank,
	getAllQuestionTags,
	moveDataBankQuesData,
} from "../../utils/apiFunctions";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";
// import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
	name: "Databank",
	// components: {
	//   Spinner,
	// },
	props: {
		role: String,
		movestatus: Boolean,
		viewQuestionBank: Boolean,
		autosectionID: String,
		type: String,
		sort: Number,
		ttype: String,
		tsort: Number,
		autoType: String,
		autoSort: Number,
		isLocked: Boolean,
	},
	mixins: [successToast, errorToast],

	data() {
		return {
			LoaderStatus: false,
			selected: [],
			storeselected: [],
			sort_selected: null,
			filtercount: 0,
			overlayOpacity: 0.46,
			searchname: "",
			searchquestiontag: "",
			showsortcard: false,
			sortoptions_selected: "",
			showfiltercard: false,
			dbfilterdrop: false,
			showdiffoptions: false,
			questionTagOpen: false,
			selectall: false,
			selectedQuestions: [],
			allQuestionTags: [],
			questionType: ["MCQU", "MAFO", "LONG"],
			currentPage: 1,
			total: 0,
			question_count: 50,
			pageStart: null,
			addMulti: false,
			pageEnd: null,
			nextPage: null,
			goToPage: null,
			totalPages: null,
			diffoptions: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],
			mediatypeOptions: [
				{ text: "Image", value: "Image" },
				{ text: "Audio", value: "Audio" },
				{ text: "Video", value: "Video" },
			],
			questiontype_options: [
				{
					value: "MCQ",
					text: "Multiple Choice Question(MCQ)",
				},

				{
					value: "MTF",
					text: "Match the Following(MTF)",
				},

				{
					value: "Descriptive",
					text: "Descriptive(DESC)",
				},
			],
			filter_questiontype_options: [
				{
					value: "MCQU",
					text: "Multiple Choice Question(MCQ)",
				},
				{
					value: "MAFO",
					text: "Match the Following(MTF)",
				},
				{
					value: "LONG",
					text: "Descriptive(DESC)",
				},
			],

			sortoptions: [
				{
					value: "",
					text: "No Sort",
				},
				{
					value: "asclevel",
					text: "Difficulty Level (Ascending)",
				},
				{
					value: "desclevel",
					text: "Difficulty Level (Descending)",
				},
				{
					value: "ascmarks",
					text: "Marks (Ascending)",
				},
				{
					value: "descmarks",
					text: "Marks (Descending)",
				},
			],
			filter_options: [
				{
					value: "a",
					text: "Filter",
				},
				{
					value: "b",
					text: "MCQs",
				},
				{
					value: "c",
					text: "Match the followings",
				},
				{
					value: "d",
					text: "Fill In The Blanks",
				},
			],
			some: "a",
			sortOrder: null,
			sortColumn: "",
			questionBankData: [],
			filter: {
				marks: "",
				difficulty: [],
				questionType: [],
				questionTags: [],
				selected: [],
			},
			storefilterdata: {
				marks: "",
				difficulty: [],
				questionType: [],
				questionTags: [],
				selected: [],
			},
		};
	},

	created() {
		this.LoaderStatus = true;
		this.getAllQuestionTag();
		// Function to manage tab redirect based on Sort
		this.tabRedirect();
	},

	computed: {
		clearFilterclass() {
			return (
				this.filter.questionTags == "" &&
				this.searchquestiontag == "" &&
				this.filter.difficulty == "" &&
				this.filter.marks == "" &&
				this.filter.questionType == "" &&
				this.selected == []
			);
		},
		...mapGetters("sectionVUEX", {
			selectedNormalSection: "getSelectedSection",
		}),
		...mapGetters("autotestVUEX", {
			selectedAutoSection: "getSelectedSection",
		}),
		selectedSection() {
			return this.autosectionID
				? this.selectedAutoSection
				: this.selectedNormalSection;
		},
		...mapGetters(["roles"]),
		filterallQuestionTags() {
			return this.allQuestionTags.filter((data) => {
				return (
					!this.searchquestiontag ||
					data.toLowerCase().includes(this.searchquestiontag.toLowerCase())
				);
			});
		},

		// To check if it does not contain an alphabet or zero
		isContainsNumber() {
			return !/^\d+$/.test(this.goToPage);
		},
	},
	watch: {
		selectedSection() {
			this.getQuestionBankData();
		},
		movestatus(newValue, oldValue) {
			if (newValue != oldValue) {
				this.filterdetails();
			}
		},
		viewQuestionBank(newValue, oldValue) {
			if (newValue != oldValue) {
				if (!newValue) {
					this.currentPage = 1;
					this.getQuestionBankData();
				}
			}
		},
		questionDeleted(newValue) {
			if (newValue == true) {
				this.getQuestionBankData();
			}
		},
		sortoptions_selected() {
			if (this.autosectionID) {
				this.$router.push({
					name: "AutoQPBuilder",
					query: {
						type: this.autoType,
						sort: this.autoSort,
						status: this.sortoptions_selected,
					},
				});
			} else {
				this.$router.push({
					name: "QPBuilder",
					query: {
						type: this.type,
						sort: this.sort,
						ttype: this.ttype,
						tsort: this.tsort,
						status: this.sortoptions_selected,
					},
				});
			}
		},
	},

	methods: {
		avoidNegativeAndOutOfRange(event) {
			if (
				event.key === "-" ||
				this.filter.marks.includes("-") ||
				event.key.toLowerCase() === "e"
			) {
				event.preventDefault();
			}
			const inputValue = parseInt(this.filter.marks + event.key);
			if (inputValue < 0 || inputValue > 100) {
				event.preventDefault();
			}
		},

		isImage,
		isVideo,
		isAudio,
		// Function to manage tab redirect based on Sort
		tabRedirect() {
			if (this.$route.query.status) {
				this.sortoptions_selected = this.$route.query.status;
				this.saveDatabankSort();
				return;
			}
			this.getQuestionBankData();
		},
		searchpagination() {
			if (this.searchname.length > 0) {
				this.currentPage = 1;
			}
		},
		filterFunction() {
			this.filter = { ...this.storefilterdata };
			this.selected = this.storeselected;
			this.showfiltercard = true;
			this.showsortcard = false;
			this.showdiffoptions = false;
		},
		hideSortFunction() {
			this.showsortcard = false;
		},
		hideFilterFunction() {
			this.showfiltercard = false;
		},
		hideFilterquestiontype() {
			this.dbfilterdrop = false;
		},
		hidequestagopen() {
			this.questionTagOpen = false;
		},
		hidediffoptions() {
			this.showdiffoptions = false;
		},
		selectAll() {
			if (this.selectall) {
				for (let i in this.questionBankData) {
					if (
						this.selectedQuestions.filter(
							(value) => value == this.questionBankData[i].questionKey
						).length === 0
					) {
						this.selectedQuestions.push(this.questionBankData[i].questionKey);
					}
				}
			} else {
				for (let j in this.questionBankData) {
					if (
						this.selectedQuestions.filter(
							(value) => value == this.questionBankData[j].questionKey
						).length > 0
					) {
						this.selectedQuestions.splice(
							this.selectedQuestions.indexOf(
								this.questionBankData[j].questionKey
							),
							1
						);
					}
				}
			}
		},
		deselect() {
			this.selectall = false;
			const containsAll = this.questionBankData.every((element) => {
				return this.selectedQuestions.includes(element.questionKey);
			});
			if (containsAll) {
				this.selectall = true;
			}
		},
		clearSearch() {
			this.LoaderStatus = true;
			this.searchname = "";
			this.getQuestionBankData();
		},
		async getQuestionBankData() {
			try {
				const isCommu = this.selectedSection?.communicationSection;

				let payload = {
					page: this.currentPage - 1,
					count: this.question_count,
					filters: {
						sectionID: this.selectedSection.sectionID,
						testID: this.$route.params.testID,
						QuesType: isCommu ? ["COMU"] : this.questionType,
						diffLevel: this.filter.difficulty,
						marks: this.filter.marks,
						questionTag: this.filter.questionTags,
						mediaType: this.selected,
					},
					sortBy: {
						column: this.sortColumn,
						order: this.sortOrder,
					},
					searchQuery: this.searchname,
				};
				if (payload.filters.marks === "") delete payload.filters.marks;
				if (payload.filters.diffLevel?.length === 0)
					delete payload.filters.diffLevel;
				if (payload.filters.questionTag?.length === 0)
					delete payload.filters.questionTag;
				if (!payload.filters.mediaType) delete payload.filters.mediaType;
				if (!payload.sortBy.column) delete payload.sortBy;
				if (!payload.searchQuery) delete payload.searchQuery;

				const res = await getDataBank(payload);
				if (res.status !== 200) return;

				this.questionBankData = res.data.data.data.map((obj) => ({
					...obj,
					view: false,
				}));

				this.pageStart = res.data.data.pageStart;
				this.nextPage = res.data.data.nextPage;
				this.pageEnd = res.data.data.pageEnd;
				this.total = res.data.data.total;

				this.totalPages = Math.ceil(
					parseInt(this.total) / parseInt(isCommu ? 50 : this.question_count)
				);

				if (!isCommu) this.checkSelectAll();

				this.$nextTick(() => {
					const scrollContainer = document.getElementById("viewqpques");
					if (scrollContainer) {
						scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
					}
				});

				this.LoaderStatus = false;

				this.$emit("questionsFetched");
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		searchnameupdate() {
			this.LoaderStatus = true;
			this.getQuestionBankData();
		},
		goToPageNum() {
			this.LoaderStatus = true;
			this.getQuestionBankData();
		},
		checkSelectAll() {
			let isSelectedAll = true;

			for (const record of this.questionBankData) {
				if (
					this.selectedQuestions.filter((value) => value === record.questionKey)
						.length === 0
				) {
					isSelectedAll = false;
				}
			}

			this.selectall = isSelectedAll;
		},

		// The pagination buttons functionality allow you to move backward and forward through the page
		goToPageNo(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getQuestionBankData();
		},
		clearfilter() {
			this.filter = {
				marks: "",
				difficulty: [],
				questionType: [],
				questionTags: [],
				selected: [],
			};
			this.storefilterdata = {
				marks: "",
				difficulty: [],
				questionType: [],
				questionTags: [],
				selected: [],
			};
			this.storeselected = [];
			this.selected = [];
			this.questionType = ["MCQU", "MAFO", "LONG"];
			if (this.filtercount != 0) {
				this.getQuestionBankData();
			}
			this.filtercount = 0;
			this.showfiltercard = false;
		},
		clearfilterbox() {
			this.filter = {
				marks: "",
				difficulty: [],
				questionType: [],
				questionTags: [],
				selected: [],
			};
			this.storefilterdata = {
				marks: "",
				difficulty: [],
				questionType: [],
				questionTags: [],
				selected: [],
			};
			this.selected = [];
			this.storeselected = [];
			this.questionType = ["MCQU", "MAFO", "LONG"];
			this.filtercount = 0;
		},
		async getAllQuestionTag() {
			try {
				const res = await getAllQuestionTags();
				if (res.status == 200) {
					this.allQuestionTags = res.data.data.questionTags;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		applyfilter() {
			this.storefilterdata = { ...this.filter };
			this.storeselected = this.selected;
			this.filtercount = 0;
			if (this.filter.questionType.length == 0) {
				this.questionType = ["MCQU", "MAFO", "LONG"];
			} else {
				this.questionType = this.filter.questionType;
				this.filtercount++;
			}
			if (this.filter.marks != "") {
				this.filtercount++;
			}
			if (this.filter.difficulty.length != 0) {
				this.filtercount++;
			}
			if (this.filter.questionTags.length != 0) {
				this.filtercount++;
			}
			if (this.selected.length != 0) {
				this.filtercount++;
			}
			this.getQuestionBankData();
		},
		async saveDatabankSort() {
			if (this.sortoptions_selected == "asclevel") {
				this.sortColumn = "difficultyLevel";
				this.sortOrder = true;
			} else if (this.sortoptions_selected == "desclevel") {
				this.sortColumn = "difficultyLevel";
				this.sortOrder = false;
			} else if (this.sortoptions_selected == "ascmarks") {
				this.sortColumn = "marks";
				this.sortOrder = true;
			} else if (this.sortoptions_selected == "descmarks") {
				this.sortColumn = "marks";
				this.sortOrder = false;
			} else {
				this.sortColumn = "";
			}
			this.getQuestionBankData();
		},
		async addQuestionFromDB(ques, questype) {
			try {
				this.LoaderStatus = true;
				let payload = {
					testID: this.selectedSection.testID,
					sectionID: this.selectedSection.sectionID,
					questionKey: [ques.questionKey],
					questionType: [questype],
				};

				if (this.$route.name == "AutoQPBuilder") {
					payload.sectionID = this.autosectionID;
					payload.testID = this.$route.params.testID;
				}

				const res = await moveDataBankQuesData(payload);
				if (res.status == 200) {
					this.LoaderStatus = false;
					this.selectedQuestions = [];
					this.$emit("question-added");
					// await this.getQuestionBankData();
					this.$nextTick(() => {
						this.successToast("Question added to section successfully!");
					});
				}
			} catch (error) {
				this.LoaderStatus = false;
				this.errorToast("Something went wrong!");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		filterdetails() {
			if (this.movestatus) {
				for (let j in this.finalQBDetails) {
					for (let i in this.selectedQuestions) {
						if (
							this.selectedQuestions[i].questionKey ==
							this.finalQBDetails[j].questionKey
						) {
							this.finalQBDetails.splice(j, 1);
						}
					}
				}
				this.selectedQuestions = [];
			}
		},

		movequestions(data) {
			if (this.selectedQuestions.length == 0) {
				this.selectedQuestions.push(data);
			} else {
				let index = this.selectedQuestions.findIndex(
					(i) => i.questionKey === data.questionKey
				);
				if (index > -1) {
					this.selectedQuestions.splice(index, 1);
				} else {
					this.selectedQuestions.push(data);
				}
			}
			this.$store.commit(
				"questionVUEX/saveMoveSelectedQuestions",
				this.selectedQuestions
			);
			if (this.selectedQuestions.length == 10) {
				window.alert("You cannot select more than 10 questions at a time");
			}
		},
		async moveAllQuestions() {
			this.LoaderStatus = true;
			let queskey = [];
			this.selectedQuestions.forEach((element) => {
				if (!queskey.includes(element.slice(0, 4))) {
					queskey.push(element.slice(0, 4));
				}
			});
			let payload = {
				testID: this.selectedSection.testID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.selectedQuestions,
				questionType: queskey,
			};
			if (this.$route.name == "AutoQPBuilder") {
				payload.sectionID = this.autosectionID;
				payload.testID = this.$route.params.testID;
			}
			const res = await moveDataBankQuesData(payload);

			if (res.status == 200) {
				this.LoaderStatus = false;
				this.currentPage = 1;
				this.successToast(
					this.selectedQuestions.length +
						" Questions added to section successfully"
				);

				this.$emit("changeViewDataBank");
				this.$emit("question-added");
				// this.getQuestionBankData();
			}
			this.selectedQuestions = [];
			this.addMulti = false;
			this.$forceUpdate();
		},
	},
};
</script>

<style scoped>
.filter-search-notfound {
	font-size: 14px;
	color: #696969;
}

.filter-search-text {
	color: #696969;
	font-size: 14px;
	font-weight: bold;
}

.filter-count {
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	display: flex;
	align-items: center;
	justify-content: center;
}

.new-recsearchicon-pos {
	position: absolute;
	top: 7px;
	left: 6px;
}

.scrolldatabank {
	overflow-x: hidden;
	overflow-y: hidden;
}

.radio {
	color: #72738e;
	font-size: 11px;
	padding-top: 4px;
	margin-left: 1px;
	margin-right: 1px;
	padding-right: 0px;
}

.selectall {
	color: #696969;

	padding: 5px;
	font-family: "Poppins", sans-serif;
	font-style: Regular;
	font-size: 12px;

	vertical-align: top;
}

.search-width {
	width: 40%;
}
</style>
<style scoped>
.questionbank-header {
	display: flex;
	align-items: center;
}

.databank-card {
	border: none;
	display: flex;
	justify-content: center;
	margin-top: 15px;
	overflow: auto;
	margin-left: 10px;
	box-shadow: 1px 1px 3.5px 1px #d9d9d9;
}

.form-control:focus {
	border-color: inherit;
	-webkit-box-shadow: none;
	box-shadow: none;
}

.icon-dos {
	display: flex;
	border-radius: 20px;
	align-items: center;
}

.search-icon {
	position: absolute;
	padding-left: 0.7rem;
	z-index: 1;
	color: #a2a2a2;
}

.search-con {
	border-radius: 20px;
	background-color: transparent;
	border-color: #e6e6e6;
	color: #a2a2a2;
	position: relative;
	padding-left: 2rem;
}

.databank-title {
	margin-left: -4px;
	font-size: 18px;
	font-weight: 500px;
	margin-top: 10px;
	color: #4b4d4e;
}

.icon-image {
	position: absolute;
	margin-top: 7px;
	margin-left: 10px;
	z-index: 1;
	color: #4b4d4e !important;
}

.sort-dropdown {
	position: relative;
}

.dropdown {
	padding-left: 1.7rem;
	width: 100px;
	height: 32px !important;
	border: 1px solid #dee2e6;
	background-color: #ffffff;
}

.dropdown:hover {
	color: #4b4d4e;
	background-color: #ffffff;
}

.dropdown:focus,
.dropdown.focus {
	border: 1px solid #a2a2a2;
	color: #4b4d4e !important;
	background-color: #ffffff !important;
	box-shadow: 0 0 0 0 !important;
}

.sort-icon {
	margin-left: 0px;
}

.filter-icon {
	margin-left: 0.4rem;
}

.mostly-customized-scrollbar::-webkit-scrollbar-thumb {
	background: #cccccc;
	height: 27vh;
	width: 55vh;
	margin-left: -35px;
	margin-top: 15px;
	border-radius: 10px;
}

.mostly-customized-scrollbar::-webkit-scrollbar {
	width: 10px;
	height: 8px;
	background-color: #e4e4e4;
	box-shadow: inset 0 3px 5px #c9c9c9;
	border-radius: 10px;
}

.quest {
	max-height: 463px;
	overflow-y: auto;
	margin-bottom: 5px;
}

.search-ques {
	box-sizing: border-box;
	padding-left: 25px;
	padding-right: 30px;
	left: 102px;
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
	border-radius: 3px;
}

.db-ques-cards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px #ffffff;
}

.db-ques-fullcards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px #ffffff;
}

.dbquesfullcards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px solid #ffffff;
}

.dbquescards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px solid #ffffff;
}

.selquessubcontainer {
	background: #e8f0fe;
	border: 1px solid #3379b3;
	box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);
	border-radius: 10px;
}

.sec-qb-text-view {
	font-size: 16px;
	font-weight: var(--weight-M);
	color: var(--bg-primary);
}

.sel-ques-sub-container {
	background: #e8f0fe;
	border: 1px solid #3379b3;
	box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);
	border-radius: 10px;
}

.minimize-right {
	background: #ffffff;
	box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.25);
	width: 34px;
	border-radius: 20px;
	height: 34px;
	display: flex;
	padding: 10px;
	align-items: center;
}
.Movebtn {
	margin-left: 70%;
}
</style>
